import React, { Component } from 'react';
import 'antd/dist/antd.css';
import { List, Avatar, Button } from 'antd';
import { Spinner } from 'reactstrap';
import axios from '../../utils/request';
import { CloudDownloadOutlined } from '@ant-design/icons';
import './ChangJiangCunChu.css';

let tenantId = "";

export class ChangJiangCunChuEvaluationReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isReady: false,
            isLoading: true,
            errorMessage: "",
            evaluationReports: [],
            personIds: "",
            tenantId: "",
            userId: "",
            commonParamater: "",
            applyId: "",
            applicantId: ""
        }
    };

    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        let commonParamater = urlParams.get("commonParamater");
        let applyId = urlParams.get("applyId");
        let applicantId = urlParams.get("applicantId");
        tenantId = urlParams.get("tenantId");

        //参数校验
        if (!commonParamater) {
            this.setState({ errorMessage: "commonParamater不存在！", isLoading: false, isReady: true });
            return;
        }

        this.state.commonParamater = commonParamater;
        this.state.tenantId = tenantId;
        this.state.applyId = applyId;
        this.state.applicantId = applicantId;
        this.loadPage(tenantId, commonParamater, applyId, applicantId);

        window.addEventListener('pageshow', function (event) {
            console.log('after , pageshow :', event);
        });
    };

    previewFile = item => {
        window.open(item.previewUrl, "blank1");
    };

    downLoadFile = (item, e) => {
        window.open(item.downLoadUrl, "blank2");
        e.stopPropagation();
    };

    loadPage = (tenantId, commonParamater, applyId, applicantId) => {
        const params = {
            tenantId,
            commonParamater,
            applyId,
            applicantId
        }

        axios
            .get("/api/ChangJiangCunChuOpen/GetEvaluationReports", { params: params })
            .then(res => {
                let errorMessage = "";

                if (res.status == 200 && res.data.code == "200") {
                    this.setState({
                        evaluationReports: res.data.data
                    });
                }
                else {
                    errorMessage = "获取测评报告失败";
                    this.setState({ isLoading: false, isReady: true, errorMessage });
                }

                this.setState({ isLoading: false, isReady: true, errorMessage });
            })
            .catch(reason => {
                this.setState({ isLoading: false, isReady: true, errorMessage: "操作异常，请联系管理员！" });
            })
            .finally(
            );
    };

    render() {
        if (this.state.isReady) {
            if (this.state.errorMessage !== "") {
                return (<div style={{ textAlign: "center", padding: "32px" }}><span style={{ color: "red" }}>{this.state.errorMessage}</span></div>)
            }
            else {
                return (
                    <div class="changjiangcunchu">
                        <div style={{ paddingTop: "30px" }} />
                        <List dataSource={this.state.evaluationReports}
                            renderItem={item => (
                                <List.Item>
                                    <List.Item.Meta
                                        avatar={
                                            <Avatar shape="square" size={40} src="//stnew.beisen.com/ux/beisen-common/upaas-static/file-icons/pdf.svg" style={{ margin: "5px" }} />}
                                        title={item.fileName}
                                        description={item.description}
                                        onClick={() => this.previewFile(item)}
                                    />
                                    <Button style={{ border: "0px" }} icon={<CloudDownloadOutlined />}
                                        onClick={(e) => this.downLoadFile(item, e)}
                                    />
                                </List.Item>
                            )}
                        />
                    </div>
                )
            }
        }
        else {
            return (
                <div style={{ textAlign: "center", lineHeight: "100vh" }}>
                    <Spinner type="grow" color="primary" />
                    <Spinner type="grow" color="secondary" />
                    <Spinner type="grow" color="success" />
                    <Spinner type="grow" color="danger" />
                    <Spinner type="grow" color="warning" />
                    <Spinner type="grow" color="info" />
                    <Spinner type="grow" color="dark" />
                </div>
            );
        }
    }
}